import {useRef} from 'react';
import type {ParticipantView} from '@phonehq/rtc-core';

export const useActiveSpeaker = (participants: readonly ParticipantView[]): string | undefined => {
    const last = useRef<string | undefined>(undefined);
    const speaking = participants.find(view => view.speaking && !view.isLocal);
    if (speaking) {
        last.current = speaking.identity;
    } else if (last.current && !participants.some(view => view.identity === last.current)) {
        last.current = undefined;
    }
    return last.current;
};
